export const LocalStorageKeys = {
  AUTH_TOKEN: 'AUTH_TOKEN',
  LANGUAGE: 'LANGUAGE',
};

const put = (where, what) => {
  localStorage.setItem(where, what);
};

const get = (what) => localStorage.getItem(what);

const remove = (what) => {
  localStorage.removeItem(what);
};

export default {
  put,
  get,
  remove,
};
